import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { isEmailValid } from "../util";
import EmailInput from "./EmailInput";

export default function EmailCCInput(props) {
  const { value = "", onChange, label = "CC Email" } = props;

  const [emails, setEmails] = useState([]);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [emailInput, setEmailInput] = useState("");

  // Parse value prop into emails array on mount and when value changes
  useEffect(() => {
    if (value) {
      const emailArray = value
        .split(",")
        .map((e) => e.trim())
        .filter((e) => e);
      setEmails(emailArray);
    } else {
      setEmails([]);
    }
  }, [value]);

  const handleAddEmail = () => {
    if (emailInput && isEmailValid(emailInput)) {
      const trimmedEmail = emailInput.trim();
      if (!emails.includes(trimmedEmail)) {
        const newEmails = [...emails, trimmedEmail];
        setEmails(newEmails);
        onChange(newEmails.join(","));
      }
      setDialogOpen(false);
      setEmailInput("");
    }
  };

  const handleRemoveEmail = (emailToRemove) => {
    const newEmails = emails.filter((email) => email !== emailToRemove);
    setEmails(newEmails);
    onChange(newEmails.join(","));
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
    setEmailInput("");
  };

  return (
    <Box>
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5, alignItems: "center" }}>
        <Button
          color="secondary"
          variant="text"
          size="small"
          startIcon={<AddIcon />}
          onClick={() => {
            setDialogOpen(true);
            setEmailInput("");
          }}
        >
          CC Email
        </Button>
        {emails.map((email, index) => (
          <Chip key={index} label={email} onDelete={() => handleRemoveEmail(email)} size="small" />
        ))}
      </Box>
      <Dialog open={dialogOpen} onClose={handleDialogClose} maxWidth="xs" fullWidth>
        <DialogTitle>Add CC Email</DialogTitle>
        <DialogContent>
          <Box mt={4}>
            <EmailInput value={emailInput} onChange={(val) => setEmailInput(val)} />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button color="secondary" variant="outlined" onClick={handleDialogClose} fullWidth>
            Cancel
          </Button>
          <Button
            onClick={handleAddEmail}
            variant="contained"
            disabled={!emailInput || !isEmailValid(emailInput)}
            fullWidth
          >
            Add
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
